export const NotFound = () => (
  <article class="prose">
    <h1>Nothing here</h1>
    <p>That page does not exist yet, or the link that brought you here has stopped working.</p>
    <p>
      If you were following an invite, check you copied the whole link — an invite that is expired or already
      used says so on its own page rather than landing here.
    </p>
    <p>
      <a class="button" href="/">
        Back to the start
      </a>
    </p>
  </article>
)
